export default __webpack_public_path__ + "static/assets/1b5e51542ee3c1fe47f07486d2eed297.png";